import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {stats?.map((stat) => (
        <div
          key={stat?.id}
          className="bg-card rounded-lg p-4 md:p-6 border border-border hover:shadow-lg transition-all duration-300"
        >
          <div className="flex items-start justify-between mb-3 md:mb-4">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={20} className="md:w-6 md:h-6" color={stat?.iconColor} />
            </div>
            {stat?.trend && (
              <div className={`flex items-center gap-1 text-xs md:text-sm font-medium ${
                stat?.trend?.direction === 'up' ? 'text-success' : 'text-error'
              }`}>
                <Icon 
                  name={stat?.trend?.direction === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                  size={14} 
                  className="md:w-4 md:h-4"
                />
                <span>{stat?.trend?.value}</span>
              </div>
            )}
          </div>
          <div className="space-y-1">
            <p className="text-xs md:text-sm text-muted-foreground font-medium">{stat?.label}</p>
            <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">{stat?.value}</p>
            {stat?.subtitle && (
              <p className="text-xs text-muted-foreground">{stat?.subtitle}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;